import {
    DELETE_USER_PRODUCT_MEMBERSHIP_POOL,
    DELETE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
    DELETE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
} from 'store/actions/types';

export const deleteUserProductMembershipPool = (payload) => {
    return {
        type: DELETE_USER_PRODUCT_MEMBERSHIP_POOL,
        payload,
    };
};

export const deleteUserProductMembershipPoolFailure = (payload) => {
    return {
        type: DELETE_USER_PRODUCT_MEMBERSHIP_POOL_FAILURE,
        payload,
    };
};

export const deleteUserProductMembershipPoolSuccess = (payload) => {
    return {
        type: DELETE_USER_PRODUCT_MEMBERSHIP_POOL_SUCCESS,
        payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/product-membership-pool/deleteUserProductMembershipPool.js